module.exports = __webpack_public_path__ + "static/img/t10.25beb285.png";